<template>
    <div class="reveal hpSpeakers">
        <div class="speakers-container">

          <div class="container">            
            <div class="split-text title section-title"><p>SPEAKERS</p></div>
          </div>
          <div class="xrSpeakers topSpeakers reveal">
              <div @click="showSpeaker(iIndex)" 
                    class="xrSpeakerItem speakerFxUp" 
                    v-for="(item,iIndex) in speakers" 
                    :style="'--delay:0.8s;--index:'+iIndex"
                    :key="'speaker_'+iIndex">
                <div class="xrImg" :style="getSpeakerImg(item)">
                </div>
                <div class="xrOver">
                  <div class="xrTitle">{{item.name}} <span class="plus"><i class="fal fa-chevron-right" ></i></span></div>                
                </div>
              </div>
          </div>

          <div class="lowerSpeakers reveal">
            <div class="container lowerTitle">            
              <div class="split-text title"><p>GUEST SPEAKER</p></div>
            </div>        
            <div class="xrCom xrGuest">

                <div class="xrComItem emptyCol" v-if="guest.length==1" >
                </div>


                <div @click="showGuest(gIndex)" class="xrComItem speakerFxUp" 
                  :style="'--delay:0.1s;--index:'+gIndex"
                  v-for="(gItem,gIndex) in guest" :key="'guest_'+gIndex">
                  <div class="xrImg" :style="getSpeakerImg(gItem)"></div>
                  <div class="xrOver">
                    <div class="xrTitle">{{gItem.name}} <span class="plus"><i class="fal fa-chevron-right" ></i></span></div>                
                  </div>
                </div>
            </div>
            <div class="container lowerTitle">            
              <div class="split-text title"><p>SCIENTIFIC COMMITTEE</p></div>
            </div>        
            <div class="xrCom xrCommittee">
                <div 
                  v-for="(comItem,cIndex) in committee" 
                  @click="showCom(cIndex)" 
                  class="xrComItem speakerFxUp" 
                  :style="'--delay:0.5s;--index:'+cIndex"              
                  :key="'com_'+cIndex">

                    <div class="xrImg" :style="getSpeakerImg(comItem)"></div>
                    <div class="xrOver">
                      <div class="xrTitle">{{comItem.name}} <span class="plus"><i class="fal fa-chevron-right" ></i></span></div>                
                    </div>

                </div>
            </div>

            <div class="container lowerTitle">            
              <div class="split-text title"><p>ORGANIZING COMMITTEE</p></div>
            </div>        
            <div class="OrganizingNames">
                <span class="split-text fs16">Tali Jacoby</span>
                <span class="split-text fs16 sep">|</span>
                <span class="split-text fs16">Serge Szmukler</span>
                <span class="split-text fs16 sep">|</span>
                <span class="split-text fs16">Doron Peretz</span>
            </div>

          </div>

        </div>
    </div>
</template>


<style>
    .hpSpeakers
    {
      width: 100%;
    }
    .speakers-container
    {
        margin: auto;
        width: clamp(800px,70vw,1500px);
        text-align: center;
    }


  .xrSpeakers
  {
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(5, minmax(115px, 1fr));  
    padding-top:30px;
    clear:both;
    margin:auto;
    grid-row-gap: 5px; /* Will be used instead by browsers that do not support `row-gap` */
    row-gap: 4px; /* Used by browsers that support `row-gap` */
    column-gap: 4px;
    width: 100%;
  }
  .xrSpeakerItem
  {
    position: relative;
    width: 100%;
    height: clamp(100px,7.3vw,400px);
    background-color: #fff;
  }

  .speakerFxUp
  {
    opacity: 0;
    transform: translateY(50px);
    transition: all ease-in-out 1s;
    transition-delay: calc(var(--delay) + (0.1s * var(--index))) !important;
  }
  
  .topSpeakers.reveal.active .speakerFxUp,
  .lowerSpeakers.reveal.active .speakerFxUp
  {
    opacity: 1;transform: translateY(0px);
  }
  
  


  .xrImg
  {
    width: 100%;
    height: 100%;
    background-size: contain;    
    background-position: center center;
    background-repeat: no-repeat;
  }
  .xrOver
  {
    opacity: 0;
    background-color: rgba(32,41,72,0.9);
    width: 100%;height: 100%;
    position: absolute;
    top: 0px;left: 0px;
    color: #fff;
    font-size: 13px;
    transition: all ease 0.3s;
  }
  .xrSpeakerItem:hover .xrOver
  {
    opacity: 1;
  }
  .xrTitle
  {
    position: absolute;
    bottom: 20px;
    left: 20px;
  }


  .lowerTitle
  {
    padding: 80px 0px 0px 0px;
  }

  .xrCom
  {
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(3, minmax(115px, 1fr));  
    padding-top:30px;
    clear:both;
    margin:auto;
    width:70vw;
    max-width: 1200px;
    grid-row-gap: 5px; /* Will be used instead by browsers that do not support `row-gap` */
    row-gap: 4px; /* Used by browsers that support `row-gap` */
    column-gap: 4px;
  }
  .xrComItem
  {
    position: relative;
    width: 100%;
    height: 11vw;
    background-color: #fff;
  }
  .xrComItem.emptyCol
  {
    opacity: 0;
  }
  .xrComItem:hover .xrOver
  {
    opacity: 1;
  }













  .hpSpeakers .xrImgCircle
  {
    opacity: 0;
    /* clip-path: circle(73px at center); */
    position: relative;
    background-color:rgba(255,255,255,0.15);
    width: 180px;height: 180px;
    margin: auto;
  }
  .hpSpeakers .xrImgCircle .xrImg
  {
    opacity: 1;
    position: absolute;
    background-size: 118%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;    
    /* clip-path: circle(70px at center); */
    transition: all ease-in-out 0.3s;
  }





  .hpSpeakers .xrSpeakerItem .xrCircle
  {
    position: absolute;
    width: 180px;height: 180px;
    border-radius: 100%;
    border: solid 2px #fff;
    top: 0px;
    transform: scale(0.9);
  }  
  .xrSpeakerIntro
  {
    text-align: center;
    font-size: 16px;
  }
  .xrSpeakerIntro span
  {
    font-size: 16px;
    font-weight: 400 !important;
  }

  .OrganizingNames
  {
    clear: both;
    text-align: center;
    padding-top: 5px;
  }
  .OrganizingNames > span
  {
    display: inline-block;
  }
  .sep
  {
    padding: 0px 15px;
  }



  .xrImgCircle:hover .xrImg
  {
    /* __clip-path: circle(35px at center); */
  }
  .clip-circle {
    /* clip-path: circle(80px at center); */
    /* OLD VALUE example: circle(245px, 140px, 50px); */
    /* Yep, even the new clip-path has deprecated stuff. */
  }


  @keyframes ___cirImgOpenBase {
    from {clip-path: circle(1px at center);opacity: 0;}  
    to {transform: circle(50px at center);opacity: 1;}
  }  
  @keyframes ___cirImgOpen {
    from {clip-path: circle(1px at center);opacity: 0;}  
    to {transform: circle(40px at center);opacity: 1;}
  }  
  @keyframes xSlideTextUp {
    from {transform: translateY(40px);opacity: 0;}  
    to {transform: translateY(0);opacity: 1;}
  }
  @keyframes xSlideBtnUp {
    from {transform: translateY(20px);opacity: 0;}  
    to {transform: translateY(0);opacity: 1;}
  }

  .animation_up{
    opacity:0;
  }

    .hpSpeakers .fxTextUp.title
    {
      position: relative;
      opacity: 0.7;
    }
    .plus
    {
      margin-left: 5px;
      color: #fff;      
    }
    .plus i{
      font-size: 12px;
    }


    .hpSpeakers .fxTextUp.title .fxText
    {
/*       font-size: 17px !important;
      font-weight: 200 !important;
      letter-spacing: -0.5px !important;
 */    }
    .hpSpeakers .fxTextUp.subtitle .fxText
    {
      font-size: 14px !important;
    }

    .hpSpeakers .fxTextUp
    {
        overflow: hidden;
    }
    .hpSpeakers .fxTextUp .fxText
    {
        opacity: 0;
        position: relative;
    }    

    @media (hover: hover) {
      .xrSpeakerItem:hover{
        cursor: pointer;
      }
      .xrSpeakerItem:hover .xrImgCircle{
        opacity: 1;
      }
      .xrSpeakerItem .fxTextUp{
        transition: all ease-in 0.2s;
      }
      .xrSpeakerItem:hover .fxTextUp{
        opacity: 1;
      }
    }

      .xrCom.xrGuest
      {

      }


  @media (max-width: 850px) { 
      .xrComItem.emptyCol
      {
        display: none;
      }
      .speakers-container
      {
        width: 100vw;
      }
      .hpSpeakers .xrSpeakers
      {
        grid-template-columns: repeat(2, minmax(115px, 1fr));  
        width:85vw;
        max-width: 1200px;
        grid-row-gap: 2rem; /* Will be used instead by browsers that do not support `row-gap` */
        row-gap: 4px; /* Used by browsers that support `row-gap` */
      }    
      .hpSpeakers .container .title div
      {
        /* font-size: 24px !important; */
      }

      .xrSpeakerItem
      {
        width: 100%;
        height: 25vw;        
      }

      .xrCom.xrGuest
      {
        grid-template-columns: 1fr;
        width: 70vw;
      }
      .xrCom.xrGuest .xrComItem {
          height: 35vw;        
      }
      .xrCom.xrCommittee
      {
        grid-template-columns: 1fr;
      }
      .xrCom.xrCommittee .xrComItem {
          height: 35vw;        
      }
      .OrganizingNames > span
      {
        display: block;
        padding: 5px 0px;
      }
      .OrganizingNames > .sep
      {
        display: none;
      }
  }

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {

    }

    /* Landscape iPad mini 1, iPad 1 and iPad 2 */
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: landscape)
    {

    }  


    @media (min-width: 1800px) 
    {
/*       .xrCom,
      .xrSpeakers{
        width: 80vw;
        max-width: 1800px;        
      }
 */
    }
    

</style>


<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";
import site_data from "@/site_data.json"

export default {
  name: "hpSpeakers",
  data()
  {
    return {
      speakers:site_data[1].SPEAKERS,
      committee:site_data[1].COMMITTEE,
      guest:site_data[1].GUEST
    }
  },
  mounted()
  {
    //todo:
    //if using desktop,    
    //disable pointer-events to this section,
      //when scrolled to this section:
        //if section is not revealed yet
          //add timer for mouse-events active 
  },
  methods:
  {
    showGuest(index)
    {
      this.$emit("show-guest",index);
    },
    showCom(index)
    {
      this.$emit("show-com",index);
    },
    showSpeaker(index)
    {
      this.$emit("show-speaker",index);
    },
    getFxIndex(index,addIndex)
    {
      let fxIndex = (index+addIndex);
      return '--index:' + fxIndex;
    },
    getSpeakerImg(item)
    {
      if(item.img.indexOf('http')>-1)
      {
        return "background-image: url('"+item.img+"')";
      }
      return "background-image: url('img/speakers/"+item.img+"')";
    }
  }
};
</script>

